import CssBaseline from "@mui/material/CssBaseline";
import React from "react";
import { createRoot } from "react-dom/client";
import { initializeLoading } from "./utils/showLoading";
import { setupGlobalErrorHandlers } from "./utils/errorHandler";
import ErrorBoundary from "./components/ErrorBoundary";

import App from "./App";

const finishLoading = initializeLoading();
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

setupGlobalErrorHandlers();

root.render(
    <CssBaseline>
        <ErrorBoundary componentName="App">
            <App />
        </ErrorBoundary>
    </CssBaseline>
);

setTimeout(finishLoading, 1000);

// CC_RESPONDI_WEBAPP: guarda o convite de instalacao do navegador o mais cedo possivel (ele pode
// disparar antes do React montar o botao "Instalar app" no topo).
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); window.__ccInstallPrompt = e; });

// CC_PWA_LEVE (2026-09-22): registra o service worker (public/service-worker.js) so pra
// habilitar "Adicionar a tela inicial"/instalacao como app no celular.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}